import React from 'react';
import './hyperlink.scss';

function Hyperlink({ hyperlinkData }) {
  const { origin, href, a, jump } = hyperlinkData;
  return (
    <a
      className={`hyperLink hyperLink--${origin}`}
      href={href ? href : jump}
      target={href ? '_blank' : '_self'}
      rel="sponsored"
    >
      {a}
    </a>
  );
}

export default Hyperlink;
